<template>
  <div class="sectionOuterBox bgPurple cWhite">
    <div class="sectionInnerBox text-left py-12">
      <v-container class="container">
        <v-row>
          <v-col md="6" sm="12">
            <div class="sectionListHeader md">{{ $t('teachers.templates.title') }}</div>
            <div class="sectionImage2 hidden-md hidden-lg hidden-xlg my-10">
              <img class="boxShadow borderRadius8" src="https://cdn.planbook.com/images/teacherTemplate.png"
                :alt="$t('teachers.templates.imageAlt')">
            </div>
            <div>
              <ul class="sectionList md pl-0 my-4">
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('teachers.templates.features.automation') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('teachers.templates.features.content') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('teachers.templates.features.standards') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('teachers.templates.features.apply') }}</span></li>
              </ul>
            </div>
          </v-col>
          <v-col md="6" sm="12" class="hidden-xs hidden-sm hidden-xxs">
            <div class="sectionImage2">
              <img class="boxShadow borderRadius8" src="https://cdn.planbook.com/images/teacherTemplate.png"
                :alt="$t('teachers.templates.imageAlt')">
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Tempaltes extends Vue {
}
</script>

<style lang="scss" scoped></style>
